import axios from 'axios'
import { Dimensioner, FreightSnapScan } from './types'

const DIMENSIONERS = '/applet/v1/dimensioners'
const FREIGHTSNAP = '/applet/v1/freightsnap'
const FREIGHTSNAP_SCAN = '/applet/v1/freightsnap/scan'

const SCAN_TIMEOUT = 40000

export const freightSnapErrorMessage = (error: any): string | undefined => {
    if(error?.code === 'ECONNABORTED' || /timeout/i.test(error?.message || '')){
        return "The dimensioner didn't respond. Check the device is on and connected, then try again."
    }
    if(error?.response?.status === 401) return undefined
    const msg: string = error?.response?.data?.error?.message || ''
    if(/FreightSnap request failed/i.test(msg)){
        return "The dimensioner didn't respond. Check the device is on and connected, then try again."
    }
    if(/Dimensioner not found/i.test(msg)){
        return "This dimensioner isn't set up. Pick another one."
    }
    if(/not enabled/i.test(msg)){
        return "FreightSnap isn't enabled for this location."
    }
    return undefined
}

export const getDimensioners = async (shippingLocationId?: string | number): Promise<Dimensioner[]> => {
    const {data} = await axios.get(DIMENSIONERS, {params: {shippingLocationId, active: true, limit: 100}})
    const results = data?.data?.results ?? data?.data ?? []
    return (Array.isArray(results) ? results : []).map((d: any) => ({
        dimensionerId: d.id ?? d.dimensionerId,
        locationId: d.locationId,
        name: d.name,
        active: d.active,
        defaultPackageType: d.defaultPackageType,
    }))
}

export const freightSnapScan = async (params: {
    locationId?: string | number
    dimensionerId: string | number
    BOLNumber?: string
}): Promise<FreightSnapScan> => {
    const {data} = await axios.get(FREIGHTSNAP_SCAN, {params, timeout: SCAN_TIMEOUT})
    const r = data?.data?.results ?? data?.data ?? {}
    return {
        id: String(r.id ?? ''),
        proNumber: r.proNumber,
        length: parseFloat(r.length) || 0,
        width: parseFloat(r.width) || 0,
        height: parseFloat(r.height) || 0,
        dimensionUom: r.dimensionUom || 'in',
        weight: parseFloat(r.weight) || 0,
        weightUom: r.weightUom || 'lbs',
        volume: parseFloat(r.volume) || undefined,
        volumeUom: r.volumeUom,
        images: Array.isArray(r.images) ? r.images : [],
        imageCount: parseInt(r.imageCount, 10) || 0,
    }
}

export const getFreightSnapFile = async (freightSnapId: string | number, kind: 'images' | 'certificate'): Promise<Blob> => {
    const {data} = await axios.get(`${FREIGHTSNAP}/${freightSnapId}/${kind}`, {responseType: 'blob'})
    return data
}
